import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'

import { createReduxStore, saga } from './store'
import rootSaga from './sagas'
import AppRouter from './AppRouter'
import ModalProvider from './modules/redux-modal/ModalProvider'
import { fetchLoginState } from './actions/auth'
import './modules/i18n/i18n'

import {
  PORTAL_IMAGE_STORE_MODAL,
  IMAGE_EDIT_MODAL,
  PORTAL_GALLERY_IMAGE_FORM_MODAL,
  PORTAL_LINK_IMAGE_FORM_MODAL,
  PORTAL_CREATE_MODAL,
  IMAGE_ACTION_MODAL,
  TOWN_BANNER_ITEM_MODAL,
  LISTING_PORTAL_SEARCH_MODAL,
  SHOW_QRCODE_MODAL as QRCODE_MODAL,
} from './constants/modalType'
import PortalImageStoreModalWithRedux from './components/templates/portal-image-store/PortalImageStoreModalWithRedux'
import ImageEditModalWithRedux from './components/templates/image-management/ImageEditModalWithRedux'
import PortalGalleryImageFormModalWithRedux from './components/templates/portal-gallery-image/PortalGalleryImageFormModalWithRedux'
import PortalLinkImageFormModalWithRedux from './components/templates/portal-link/PortalLinkImageFormModalWithRedux'
import PortalCreateModalWithRedux from './components/templates/portal-create/PortalCreateModalWithRedux'
import ImageActionModalWithRedux from './components/templates/image-management/ImageActionModalWithRedux'
import BannerItemModalWithRedux from './components/templates/banner-item/BannerItemModalWithRedux'
import ListingPortalSearchModalRedux from './components/templates/listing-portal/ListingPortalSearchModalRedux'
import QRCodeModalWithRedux from './components/templates/qrcode/QRCodeModalWithRedux'
import { initTownIfHave } from './actions/town'

import { initializeFirebase } from './modules/firebase'

const MODAL_COMPONENTS = {
  [IMAGE_ACTION_MODAL]: ImageActionModalWithRedux,
  [IMAGE_EDIT_MODAL]: ImageEditModalWithRedux,
  [PORTAL_IMAGE_STORE_MODAL]: PortalImageStoreModalWithRedux,
  [PORTAL_GALLERY_IMAGE_FORM_MODAL]: PortalGalleryImageFormModalWithRedux,
  [PORTAL_LINK_IMAGE_FORM_MODAL]: PortalLinkImageFormModalWithRedux,
  [PORTAL_CREATE_MODAL]: PortalCreateModalWithRedux,
  [TOWN_BANNER_ITEM_MODAL]: BannerItemModalWithRedux,
  [LISTING_PORTAL_SEARCH_MODAL]: ListingPortalSearchModalRedux,
  [QRCODE_MODAL]: QRCodeModalWithRedux,
}

const store = createReduxStore()

initializeFirebase()
saga.run(rootSaga)
store.dispatch(fetchLoginState())

setTimeout(() => {
  store.dispatch(initTownIfHave())
}, 2000)

ReactDOM.render(
  <div>
    <Provider store={store}>
      <div>
        <AppRouter />
        <ModalProvider modalComponents={MODAL_COMPONENTS} />
      </div>
    </Provider>
    <ToastContainer />
  </div>,
  document.getElementById('root'),
)
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js